import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    Output
} from '@angular/core';
import {fromEvent, Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {createDisplaySymbol, DisplaySymbol} from '../../common/display-symbol';
import {TypedSimpleChanges} from '../../common/typed-on-changes';
import {Security} from '../../models/security';
import {SecurityKey} from '../../models/security-key';
import {TooltipDirective} from '../tooltip/tooltip.directive';

const IS_CLICKABLE_CLASS = '-clickable';

@Component({
    selector: 'display-symbol',
    templateUrl: './display-symbol.component.html',
    styleUrls: ['./display-symbol.component.scss'],
    preserveWhitespaces: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisplaySymbolComponent implements OnInit, OnChanges {

    @Input()
    public security: SecurityKey | Security;

    @Input()
    public hideExchange: boolean = false;

    @Input()
    public tooltipDirective: TooltipDirective;

    @Output('click')
    public readonly outerClickEventEmitter = this.createClickEventEmitter();

    @HostBinding(`class.${IS_CLICKABLE_CLASS}`)
    public isClickable: boolean = false;

    public displaySymbol: DisplaySymbol;

    constructor(
        private elementRef: ElementRef
    ) {}

    public ngOnInit(): void {
        this.updateDisplaySymbol();
    }

    public ngOnChanges(changes: TypedSimpleChanges<DisplaySymbolComponent>): void {
        if (changes.security && !changes.security.firstChange) {
            this.updateDisplaySymbol();
        } else if (changes.tooltipDirective) {
            this.updateTooltip();
        }
    }

    protected updateDisplaySymbol(): void {
        this.displaySymbol = (this.security)
            ? createDisplaySymbol(this.security, this.hideExchange)
            : undefined;

        this.updateTooltip();
    }

    private createClickEventEmitter(): Observable<MouseEvent> {
        return new Observable<MouseEvent>(subscriber => {
            const click$ = fromEvent<MouseEvent>(this.elementRef.nativeElement, 'click');

            click$.subscribe(subscriber);
            this.isClickable = true;

            return () => this.isClickable = false;
        }).pipe(
            share()
        );
    }

    private updateTooltip(): void {
        if (this.tooltipDirective) {
            const displayStr = this.displaySymbol
                ? this.displaySymbol.displayStr
                : '';

            this.tooltipDirective.setDynamicTooltip(true, displayStr);
        }
    }

}
